import { render, staticRenderFns } from "./disability-section.vue?vue&type=template&id=57da9fc6"
import script from "./disability-section.vue?vue&type=script&lang=js"
export * from "./disability-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports